import { render, staticRenderFns } from "./Select-Customer.vue?vue&type=template&id=3719d4b0&scoped=true"
import script from "./Select-Customer.vue?vue&type=script&lang=js"
export * from "./Select-Customer.vue?vue&type=script&lang=js"
import style0 from "./Select-Customer.vue?vue&type=style&index=0&id=3719d4b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3719d4b0",
  null
  
)

export default component.exports